import { useMemo } from 'react';

export const useMemoizedValue = <T>(value: T): T => {
  return useMemo(() => value, [JSON.stringify(value)]);
};
